import type { Story } from '@/store/story-types'

import { AGENCY_STUDIO_STORY } from './agency-studio-story'
import { AI_SAAS_LANDING_STORY } from './ai-saas-landing-story'
import { BEAUTY_PICKS_STORE_STORY } from './beauty-picks-store-story'
import { CAFE_ORDER_APP_STORY } from './cafe-order-app-story'
import { CONTENT_HUB_STORY } from './content-hub-story'
import { CREATOR_BLOG_STORY } from './creator-blog-story'
import { CREATOR_DIGITAL_SHOP_STORY } from './creator-digital-shop-story'
import { CREATOR_PORTFOLIO_STORY } from './creator-portfolio-story'
import { CURATION_COMMERCE_STORY } from './curation-commerce-story'
import { DEV_PORTFOLIO_STORY } from './dev-portfolio-story'
import { DIGITAL_ACADEMY_STORY } from './digital-academy-story'
import { DIGITAL_PRODUCTS_STORE_STORY } from './digital-products-store-story'
import { FAN_CLUB_STORE_STORY } from './fan-club-store-story'
import { FASHION_CREATOR_STORE_STORY } from './fashion-creator-store-story'
import { FOOD_DELIVERY_APP_STORY } from './food-delivery-app-story'
import { GROUP_BUYING_STORY } from './group-buying-story'
import { K_BEAUTY_STORE_STORY } from './k-beauty-store-story'
import { K_FASHION_STORE_STORY } from './k-fashion-store-story'
import { LANDING_PAGE_STORY } from './landing-page-story'
import { LINK_IN_BIO_CLASSIC_STORY } from './link-in-bio-classic-story'
import { LINK_IN_BIO_STORE_STORY } from './link-in-bio-store-story'
import { LIVE_COMMERCE_STORY } from './live-commerce-story'
import { MEMBERSHIP_CLUB_STORY } from './membership-club-story'
import { ONLINE_STORE_STORY } from './online-store-story'
import { PRODUCT_LAUNCH_STORY } from './product-launch-story'
import { PROXY_BUYING_CATALOG_STORY } from './proxy-buying-catalog-story'
import { PROXY_BUYING_STORY } from './proxy-buying-story'
import { RESTAURANT_APP_STORY } from './restaurant-app-story'
import { SOCIAL_MARKETPLACE_STORY } from './social-marketplace-story'
import { SOCIAL_SHOPPING_STORY } from './social-shopping-story'
import { STREETWEAR_DROP_STORY } from './streetwear-drop-story'
import { TECH_REVIEW_STORE_STORY } from './tech-review-store-story'

// v2 (-new3) template stories
import { AGENCY_STUDIO_NEW3_STORY } from './agency-studio-new3-story'
import { ANALYTICS_DASHBOARD_NEW3_STORY } from './analytics-dashboard-new3-story'
import { COFFEE_SHOP_STORE_NEW3_STORY } from './coffee-shop-store-new3-story'
import { CREATOR_BLOG_NEW3_STORY } from './creator-blog-new3-story'
import { DEV_PORTFOLIO_NEW3_STORY } from './dev-portfolio-new3-story'
import { FITNESS_GYM_NEW3_STORY } from './fitness-gym-new3-story'
import { FOOD_DELIVERY_NEW3_STORY } from './food-delivery-new3-story'
import { PET_SUPPLY_STORE_NEW3_STORY } from './pet-supply-store-new3-story'
import { PROJECT_TRACKER_NEW3_STORY } from './project-tracker-new3-story'
import { TECH_GADGET_STORE_NEW3_STORY } from './tech-gadget-store-new3-story'

export const TEMPLATE_STORIES: Record<string, Story> = {
  'landing-page': LANDING_PAGE_STORY,
  'fashion-creator-store': FASHION_CREATOR_STORE_STORY,
  'beauty-picks-store': BEAUTY_PICKS_STORE_STORY,
  'fan-club-store': FAN_CLUB_STORE_STORY,
  'digital-products-store': DIGITAL_PRODUCTS_STORE_STORY,
  'tech-review-store': TECH_REVIEW_STORE_STORY,
  'creator-digital-shop': CREATOR_DIGITAL_SHOP_STORY,
  'streetwear-drop': STREETWEAR_DROP_STORY,
  'creator-portfolio': CREATOR_PORTFOLIO_STORY,
  'link-in-bio-classic': LINK_IN_BIO_CLASSIC_STORY,
  'link-in-bio-store': LINK_IN_BIO_STORE_STORY,
  'creator-blog': CREATOR_BLOG_STORY,
  'content-hub': CONTENT_HUB_STORY,
  'online-store': ONLINE_STORE_STORY,
  'cafe-order-app': CAFE_ORDER_APP_STORY,
  'food-delivery-app': FOOD_DELIVERY_APP_STORY,
  'restaurant-app': RESTAURANT_APP_STORY,
  'curation-commerce': CURATION_COMMERCE_STORY,
  'proxy-buying-catalog': PROXY_BUYING_CATALOG_STORY,
  'proxy-buying': PROXY_BUYING_STORY,
  'k-fashion-store': K_FASHION_STORE_STORY,
  'k-beauty-store': K_BEAUTY_STORE_STORY,
  'group-buying': GROUP_BUYING_STORY,
  'digital-academy': DIGITAL_ACADEMY_STORY,
  'social-marketplace': SOCIAL_MARKETPLACE_STORY,
  'social-shopping': SOCIAL_SHOPPING_STORY,
  'membership-club': MEMBERSHIP_CLUB_STORY,
  'live-commerce': LIVE_COMMERCE_STORY,
  'agency-studio': AGENCY_STUDIO_STORY,
  'ai-saas-landing': AI_SAAS_LANDING_STORY,
  'product-launch': PRODUCT_LAUNCH_STORY,
  'dev-portfolio': DEV_PORTFOLIO_STORY,

  // v2 (-new3) templates
  'coffee-shop-store-new3': COFFEE_SHOP_STORE_NEW3_STORY,
  'food-delivery-new3': FOOD_DELIVERY_NEW3_STORY,
  'fitness-gym-new3': FITNESS_GYM_NEW3_STORY,
  'pet-supply-store-new3': PET_SUPPLY_STORE_NEW3_STORY,
  'tech-gadget-store-new3': TECH_GADGET_STORE_NEW3_STORY,
  'agency-studio-new3': AGENCY_STUDIO_NEW3_STORY,
  'dev-portfolio-new3': DEV_PORTFOLIO_NEW3_STORY,
  'creator-blog-new3': CREATOR_BLOG_NEW3_STORY,
  'project-tracker-new3': PROJECT_TRACKER_NEW3_STORY,
  'analytics-dashboard-new3': ANALYTICS_DASHBOARD_NEW3_STORY,
}
